import { requestConfig } from "../config.js";

/**
 * Получить ссылку на страницу оплаты
 *
 * @param {Number} contractId
 * @param {String} billingId
 * @param {Number} sumPayment
 * @param {String} source
 * @param {?String} tag
 */
export async function apiFetchTinkoffPaymentUrl(contractId, billingId, sumPayment, source, tag) {
  try {
    const redirectUrl = window.location.href;

    const response = await requestConfig.post("/tinkoff/api/v1/payments/url", {
      cid: contractId,
      bid: billingId,
      amount: sumPayment,
      platform: "WEB",
      method: "CARD",
      customer: 0,
      success_url: `${redirectUrl}?isPaid=true&source=${source}`,
      fail_url: `${redirectUrl}?isPaid=false&source=${source}`,
      tag: tag,
    });

    if (response?.data?.details) throw new Error(response.data.details.toString());
    return response;
  } catch (error) {
    throw error;
  }
}
